<template>
  <div class="wrap">
    <div class="row">
      <div v-html="content.html3"></div>
    </div>
    <table class="row">
      <tr>
        <td>
          <h1 class="row">
            {{translate('order-acknowledgment')}}
          </h1>
        </td>
        <td>
          <span class="title">{{translate('date')}}:</span>
          <span>{{ currentDate | toDate}}</span>
        </td>
      </tr>
    </table>
    <table class="row">
      <tr>
        <td style="width: 50%; border-right: 1rem solid transparent" valign="top">
          <div class="box-content">
            <h3 class="block-title table__cell">{{translate('sold-to')}}</h3>
            <div class="table__cell">
              <p>{{rfq.customerCompany.name}}</p>
              <p>{{rfq.customerCompanyDetail.street}}</p>
            </div>
            <div class="table__cell">
              {{customerAddress}}
            </div>
          </div>
        </td>
        <td style="width: 50%; border-left: 1rem solid transparent" valign="top">
          <div class="box-content">
            <table>
              <tr>
                <td>
                  <div class="title table__cell">{{translate('po')}}: </div>
                </td>
                <td>
                  <div class="table__cell">{{rfq.po}}</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="title table__cell">{{translate('date')}}: </div>
                </td>
                <td>
                  <div class="table__cell">{{rfq.poDate | toDate}}</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="title table__cell">{{translate('contact')}}: </div>
                </td>
                <td>
                  <div class="table__cell">{{rfq.customerContact.name}}</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="title table__cell">{{translate('phone')}}: </div>
                </td>
                <td>
                  <div class="table__cell">{{rfq.customerContact.phone}}</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="title table__cell">{{translate('currency')}}: </div>
                </td>
                <td>
                  <div class="table__cell">{{rfq3First.currency.title}}</div>
                </td>
              </tr>
            </table>
          </div>
        </td>
      </tr>
    </table>
    <table-list
      :columns="[
          { label: translate('qty'), renderColumn: (row) => row.qty },
          { label: translate('part-number'), renderColumn: (row) => row.part.partNumber  },
          { label: translate('description'), renderColumn: (row) => row.part.partDescription },
          { label: translate('condition'), renderColumn: (row) => row.condition.title },
          { label: translate('supply-date'), renderColumn: (row) => row.supplyDate },
          { label: translate('u/price'), renderColumn: (row) => $options.filters.toPrice(row.price * row.qty) },
        ]"
      :data="rfq3s"
    >
    </table-list>
    <table class="row">
      <tr class="table__row">
        <td align="right"><span class="title">{{translate('sub-total')}}: </span> {{subTotal | toPrice}}</td>
      </tr>
    </table>
    <div class="row">
      <h3>{{translate('remarks-and-conditions')}}:</h3>
      <p v-html="content.html1"></p>
    </div>
    <div class="row">
      <h3>{{translate('export-compliance-statement')}}:</h3>
      <p v-html="content.html2"></p>
    </div>
  </div>
</template>
<script>
import { toDate, toPrice } from '@/utils/filters'
import TableList from './components/table-list'

export default {
  name: 'PdfOrderAcknowledgment',
  components: {
    'table-list': TableList
  },
  props: {
    translate: {
      type: Function
    },
    rfq: {
      type: Object
    },
    rfq3s: {
      type: Array
    },
    content: {
      type: Object
    }
  },
  computed: {
    currentDate () {
      return new Date()
    },
    customerAddress () {
      return [
        this.rfq.customerCompanyDetail.country,
        this.rfq.customerCompanyDetail.city,
        this.rfq.customerCompanyDetail.zipCode,
        this.rfq.customerCompanyDetail.state
      ].filter(Boolean).join(', ')
    },
    rfq3First () {
      return this.rfq3s[0] || {}
    },
    subTotal () {
      return this.rfq3s.reduce((result, detail) => result + (detail.qty * detail.price), 0)
    }
  },
  filters: {
    toPrice: toPrice,
    toDate: toDate
  }
}
</script>
